export default __webpack_public_path__ + "static/media/news-small-homepage-1.1112f5b1.png";